// Components
import { ManageProfiles } from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover';
import { DatepickerGlobal } from '@/components/layouts/LayoutPlatform/components/Header/components/DatepickerGlobal';

export function DefaultLeftSide() {
    return (
        <div className="flex items-center gap-3">
            <ManageProfiles />
            <DatepickerGlobal />
        </div>
    );
}
